<template>
    <div class="ProcessTracesDrawerPanel">
        <div
            v-if="filteredTraces <= 0"
            class="text-caption text-grey-7"
        >
            {{ $t('visualization.filters.emptyModel') }}
        </div>

        <template v-else>
            <QBtn
                color="primary"
                noCaps
                outline
                icon="add_circle"
                :label="$t('visualization.traces.toDataSet')"
                class="full-width q-mb-sm"
                :disable="disableElements"
                @click="prompt = true"
            />

            <QBtn
                color="primary"
                noCaps
                outline
                icon="archive"
                :label="$t('visualization.traces.downloadCSV')"
                class="full-width q-mb-md"
                :disable="disableElements"
                @click="$emit('on-export')"
            />

            <q-expansion-item
                icon="search"
                :label="$t('actions.search')"
                defaultOpened
                class="ContextDrawerExpansion ContextDrawerExpansion--last"
                headerClass="ContextDrawerExpansionHeader"
            >
                <div class="ContextDrawerExpansionContent">
                    <QInput
                        v-model="searchProxy"
                        dense
                        outlined
                        type="search"
                        :label="$t('visualization.traces.table.search.placeholder')"
                        class="q-mb-md"
                        :disable="disableElements"
                        @keyup.enter="handleApplySearch"
                    >
                        <template #append>
                            <q-icon
                                v-if="searchProxy"
                                name="close"
                                size="20px"
                                clickable
                                style="margin-right: 0.5rem;cursor: pointer;"
                                @click="handleClearSearch"
                            />
                            <q-icon
                                name="search"
                                size="20px"
                                clickable
                                style="cursor: pointer;"
                                @click="handleApplySearch"
                            />
                        </template>
                    </QInput>
                </div>
            </q-expansion-item>

            <QDialog
                v-model="prompt"
                persistent
            >
                <QCard style="min-width: 350px">
                    <QBar class="bg-primary text-white">
                        <div class="text-subtitle1 text-weight-medium">
                            {{ $t('visualization.traces.createDataSet') }}
                        </div>
                        <QSpace />
                        <QBtn
                            dense
                            flat
                            color="white"
                            icon="close"
                            @click="prompt = false"
                        />
                    </QBar>
                    <QCardSection class="q-pt-none">
                        <QInput
                            ref="newDatasetName"
                            v-model="newDatasetName"
                            dense
                            autofocus
                            :rules="[
                                val => !!val || $t('visualization.traces.nameRequired'),
                                val => val.length > 2 || $t('visualization.traces.nameLength'),
                            ]"
                        />
                    </QCardSection>
                    <QCardActions
                        align="right"
                        class="text-primary"
                    >
                        <QBtn
                            flat
                            noCaps
                            :label="$t('visualization.traces.cancel')"
                            @click="prompt = false"
                        />
                        <QBtn
                            color="primary"
                            outline
                            noCaps
                            :label="$t('visualization.traces.create')"
                            @click="handleCreateDataset"
                        />
                    </QCardActions>
                </QCard>
            </QDialog>
        </template>
    </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'ProcessTracesDrawerPanel',
    props: {
        filteredTraces: VueTypes.oneOfType([VueTypes.string, VueTypes.number]).def(0),
        disableElements: VueTypes.bool.def(false),
        search: VueTypes.string.def(''),
    },
    emits: ['on-export', 'on-search', 'update:search', 'on-create-dataset'],
    data() {
        return {
            prompt: false,
            newDatasetName: undefined,
        }
    },
    computed: {
        searchProxy: {
            get() {
                return this.search
            },
            set(value) {
                this.$emit('update:search', value)
            },
        },
    },
    methods: {
        handleApplySearch() {
            this.$emit('on-search', { search: this.searchProxy })
        },
        handleClearSearch() {
            this.$emit('update:search', '')
            this.$emit('on-search', { search: '' })
        },
        handleCreateDataset() {
            if (this.$refs.newDatasetName?.validate?.()) {
                this.$emit('on-create-dataset', { name: this.newDatasetName })
                this.prompt = false
            }
        },
    },
}
</script>

<style scoped lang="scss">
.ProcessTracesDrawerPanel {
    width: 100%;
}

:deep(.ContextDrawerExpansion) {
    border-top: 1px solid $gray-04;
}

:deep(.ContextDrawerExpansion.ContextDrawerExpansion--last) {
    border-bottom: 1px solid $gray-04;
}

:deep(.ContextDrawerExpansionHeader .q-item__label) {
    font-weight: 700;
}

:deep(.ContextDrawerExpansionHeader .q-item__section--avatar .q-icon) {
    color: $primary;
}

.ContextDrawerExpansionContent {
    padding: 8px 16px 16px;
}
</style>
